/* ELEMENTS */
export const BODY = document.body;
export const HEADER_MAIN = document.getElementById("header-main");

/* CLASSES */
export const CLASS_BODY_OVERLAY_OPEN = "overlay-is-open";
export const CLASS_BODY_HEADER_HIDDEN = "header-is-hidden";
export const CLASS_BODY_PIP_EXTEND = "pip-extended";
export const CLASS_BODY_PIP_ON = "pip-on";
export const CLASS_BODY_FULLSCREEN_ON = "fullscreen-on";
export const CLASS_BODY_HAS_BOTTOM_BAR = "has-bottom-bar";
export const CLASS_BODY_BOTTOM_BAR_ON = "bottom-bar-on";
export const CLASS_BODY_HEADER_MAIN_OFF = "header-main-off";
export const CLASS_BODY_SCROLLING_UP = "scrolling-up";

/* MOBILE CLASSES on HEADER */
export const CLASS_MOBILE_SUBNAV_IS_OPEN = "mobile-subnav-is-open";
export const CLASS_MOBILE_SEARCH_IS_OPEN = "mobile-search-is-open";

/* AD CLASSES */
export const HIDDEN_AD_CLASS = "ad-hidden";
export const FILLED_AD_CLASS = "ad-filled"
export const ADDED_AD_CLASS = "js-added-ad";
export const INREAD_1_CLASS = "js-inread1";
export const INREAD_2_CLASS = "js-inread2";
